import { UserService } from "@/services/user.service";
import { StorageService } from "@/services/storage.service";
import moment from "moment";

const state = () => ({
  accessToken: StorageService.getToken(),
  tokenExpiresAt: StorageService.get("tokenExpiresAt"),
  filters: {},
  applications: [],
  favorites: [],
  auth: {
    lastname: "",
    phone: "",
    id: "",
    uid: "",
    expires: 0,
    newUser: StorageService.get("new_user") || false
  },
  profile: StorageService.get("profile") || {},
  invitationVerified: false,
  pkreferenz_id: "",

  registrationState: false
});

const getters = {
  loggedIn: state => !!state.accessToken,
  accessToken: state => state.accessToken,
  filters: state => state.filters,
  applications: state => state.applications,
  favorites: state => state.favorites,
  profile: state => state.profile,
  invitationVerified: state => state.invitationVerified,
  registrationState: state => state.registrationState,
  auth: state => state.auth,
  pkreferenz_id: state => state.pkreferenz_id
};

const actions = {
  verifyLastName({ state, commit }, lastname) {
    return UserService.verifyLastName(lastname, state.auth.uid)
      .then((response) => {
        commit("setLastName", response.data.last_name);
        return true;
      })
      .catch(() => {
        commit("setLastName", "");
        return false;
      });
  },
  verifyPhone({ state, commit }, phone) {
    
    return UserService.verifyPhone(phone, state.auth.lastname)
      .then(res => {
        commit("setPhone", {
          phone: res.data.phone,
          id: res.data.id,
          expires: res.data.hasOwnProperty("expires") ? res.data.expires : 60
        });
        return true;
      })
      .catch(() => {
        commit("setPhone", { phone: "", id: "", expires: 0 });
        return false;
      });
  },
  verifyOtp({ commit, state, dispatch }, otp) {
    let code = ["7471112426", "9340014930"].includes(state.auth.phone)
      ? "+91"
      : "+49";
    let args = {
      otp: otp,
      phone: state.auth.phone,
      id: state.auth.id
    };
    return UserService.verifyOtp(args)
      .then(res => {
        StorageService.save("new_user", res.data.new_user);
        commit("loginUser", res.data);

        if (!res.data.new_user) {
          StorageService.saveToken(res.data.token);
          StorageService.save("tokenExpiresAt", res.data.expires);
          dispatch("fetchProfile");
        }
        return res.data;
      })
      .catch(() => false);
  },
  validate({ state }) {
    if (!state.accessToken) return false;
    return (
      (moment(state.tokenExpiresAt)
        .local()
        .valueOf() -
        Number(new Date())) /
      1000 >
      600
    );
  },
  logout({ commit }) {
    StorageService.clear();
    commit("logout");
  },
  fetchProfile({ commit }) {
    return UserService.fetchProfile()
      .then(res => {
        res.data.cell = res.data.cell.substring(3);
        StorageService.save("profile", res.data);
        commit("setProfile", res.data);
        return res.data;
      })
      .catch(e => e);
  },
  resendOtp({ state }) {
    let code = ["7471112426", "9340014930"].includes(state.auth.phone)
      ? "+91"
      : "+49";
    return UserService.resendOtp(state.auth.phone)
      .then(res => {
        if (res.data !== "Ok") {
          state.auth.expires = res.data.expires;
        } else {
          state.auth.expires = 60;
        }
        let expireInt = setInterval(() => {
          if (state.auth.expires === 0) {
            clearInterval(expireInt);
          }
          this.commit("user/decrementOTpExpire");
        }, 1100);
      })
      .catch(() => false);
  },
  saveProfile({ state }, params) {
    return UserService.saveProfile(params)
      .then(() => true)
      .catch(() => false);
  },
  verifyInvitation({ commit }, uid) {

    return UserService.verifyInvitation(uid)
      .then(res => {
        commit("setInvitationVerification", true);
        commit("setUid", uid);
        
        return [true, res.data.language];
      })
      .catch(err => [false, err.response.data.error]);
  },
  acceptContract({ commit, state, dispatch }) {
    return UserService.acceptContract(state.auth.id)
      .then(res => {
        commit("loginUser", res.data);
        commit("setAcceptContract", 1);
        if (!res.data.new_user) {
          StorageService.saveToken(res.data.token);
          StorageService.save("tokenExpiresAt", res.data.expires);
          dispatch("fetchProfile");
        }
        return true;
      })
      .catch(() => {
        commit("setAcceptContract", 0);
        return false;
      });
  },

  deleteReference({ commit }, id) {
    return UserService.deleteReference(id)
      .then(res => {
        location.reload();
        dispatch("fetchProfile");
      })
      .catch(() => {
        return false;
      })
  }
};

const mutations = {
  setLastName(state, lastname) {
    state.auth.lastname = lastname;
  },
  setUid(state, uid) {
    state.auth.uid = uid;
  },
  setPhone(state, { phone, id, expires }) {
    state.auth.phone = phone;
    state.auth.id = id;
    state.auth.expires = expires;

    let expireInt = setInterval(() => {
      if (state.auth.expires === 0) {
        clearInterval(expireInt);
      }
      this.commit("user/decrementOTpExpire");
    }, 1100);
  },
  loginUser(state, data) {
    if (!data.new_user) {
      state.accessToken = data.token;
      state.tokenExpiresAt = data.expires;
    } else {
      state.auth.id = data.id;
    }
    state.auth.newUser = data.new_user;
  },
  logout(state) {
    state.accessToken = "";
    state.tokenExpiresAt = "";
    state.auth.newUser = true;
    state.auth.id = "";
    state.auth.phone = "";
    state.auth.lastname = "";
  },
  setProfile(state, data) {
    state.profile = data;
  },
  setInvitationVerification(state, data) {
    state.invitationVerified = data;
    state.registrationState = data;
  },
  checkRegistrationState(state) {
    state.registrationState = data;
  },
  setAcceptContract(state, data) {
    state.profile.accept_contract = data;
  },
  decrementOTpExpire(state) {
    state.auth.expires--;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
